const IndonesianAcademy = {
  beranda: 'Beranda',
  tentang: 'Tentang Akademi',
  visimisi: 'Visi Misi',
  program: 'Program',
  paket: 'Paket',
  pusatLatihan: 'Pusat Latihan',
  lainnya: 'Lainnya',
};

export default IndonesianAcademy;